import { Menu, Typography } from "antd"
import { ThunderboltFilled } from "@ant-design/icons"
import { useNavigation } from "../../../router/navigation"
import SidebarToggle from "./SidebarToggle"
import styles from "./Sidebar.module.scss"

const Sidebar = ({ collapsed = false, onToggle }) => {
  const { items, selectedKeys, openKeys } = useNavigation()

  return (
    <aside className={styles.sidebar}>
      <div className={`${styles.brand} ${collapsed ? styles.brandCollapsed : ""}`}>
        <div className={styles.logoMark}>
          <ThunderboltFilled className={styles.logoIcon} />
        </div>
        {!collapsed && <Typography.Text className={styles.brandName}>RankAttack</Typography.Text>}
        {onToggle && (
          <div className={styles.toggle}>
            <SidebarToggle collapsed={collapsed} onToggle={onToggle} />
          </div>
        )}
      </div>

      <div className={styles.menuWrap}>
        <Menu
          mode="inline"
          inlineCollapsed={collapsed}
          className={styles.menu}
          selectedKeys={selectedKeys}
          defaultOpenKeys={openKeys}
          items={items}
        />
      </div>

      <div className={`${styles.footer} ${collapsed ? styles.footerCollapsed : ""}`}>
        <span className={styles.flag} aria-hidden>
          {"\u{1F1FA}\u{1F1F8}"}
        </span>
        {!collapsed && <span className={styles.marketplace}>US Marketplace</span>}
      </div>
    </aside>
  )
}

export default Sidebar
